import React from 'react';

export interface SearchResponse {
  word: string;
  phonetics: {
    text?: string;
    audio?: string;
  }[];
  meanings: {
    partOfSpeech: string;
    definitions: {
      definition: string;
      antonyms: string[];
      synonyms: string[];
      example: string;
    }[];
  }[];
  sourceUrls: string[];
}

export interface SearchContextType {
  word: string;
  setWord: (word: string) => void;
  response: SearchResponse;
  setResponse: (response: SearchResponse) => void;
  isLoading: boolean;
}

export const SearchContext = React.createContext<SearchContextType>({
  word: '',
  setWord: () => {},
  response: {} as SearchResponse,
  setResponse: () => {},
  isLoading: false,
});